import React, { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../../../firebase/Firebase';
import { createUserWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';


const UserInput = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Admin');
  const [error, setError] = useState(null);

  const orgId = localStorage.getItem('orgId');
  console.log(orgId)


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!orgId) {
      setError("Unable to determine the organization.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, 'tempPassword123!');
      const user = userCredential.user;

      if (!user) throw new Error("No user returned from Firebase Auth.");

      await sendPasswordResetEmail(auth, email, {
        url: 'https://vasco-6851a.web.app/login',
        handleCodeInApp: false,
      });

      console.log("Password reset email sent.");

      // Update this line to target the centralized Users collection
      const userDocRef = doc(db, 'Users', user.uid);
      await setDoc(userDocRef, {
        firstName,
        lastName,
        email,
        role,
        orgId,
      });

      console.log("Document written with ID: ", user.uid);
      closeModal();

    } catch (error) {
      setError(error.message);
      console.error("Error:", error);
    }
  };



  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <div style={{ position: 'relative' }}>
      <button style={styles.button} onClick={openModal}>Add User</button>
      {isOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>First Name:</label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="First Name"
                  style={styles.input}
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Last Name:</label>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Last Name"
                  style={styles.input}
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Email:</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  style={styles.input}
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Role:</label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  style={styles.input}
                >
                  <option value="Admin">Admin</option>
                  <option value="Receiving">Receiving</option>
                  <option value="Project Manager">Project Manager</option>
                  <option value="Operations">Operations</option>
                  <option value="Accounting">Accounting</option>
                </select>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <button type="submit" style={{ ...styles.button, marginRight: '10px' }}>Add</button>
                <button onClick={closeModal} style={{ ...styles.button, backgroundColor: 'lightgray', color: '#000000' }}>Close</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000
  },
  modal: {
    width: '400px',
    padding: '20px',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
    borderRadius: '10px'
  },
  button: {
    zIndex: 1,
    padding: '10px 15px',
    border: 'none',
    background: '#FFC300',
    color: '#000000',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: '5px',
    transition: 'background 0.3s',
  },
  inputGroup: {
    marginBottom: '10px',
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    color: '#000000',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
}

export default UserInput;
